<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Членства</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Монитор продления /</span> Членства</div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-container class="col-10">
              <Block :padding="0">
                <div class="filter">
     
                  <v-card-title
                class="custom__card-title"
            >
            <div class="search_client">
                <v-text-field
                    v-model="search"
                    rounded
                    outlined
                    dense
                    hide-details
                    single-line
                    label="Поиск"
                    style="font-size: 12px;font-weight: normal"
                    background-color="white"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </div>
              <div class="filter_client">
                <v-btn
                    dark
                    class="filter-button"
                    :disabled="isLoading"
                    @click="dialogFiler = !dialogFiler"
                >
                  <img
                      class="mr-1"
                      src="/playground_assets/mediumfilter.svg"
                  >
                  Фильтр
                </v-btn>
              </div>

            </v-card-title>
                  <v-card-text
                      v-show="dialogFiler"
                  >
                    <v-container>
                      <v-row>
                        <v-col
                            cols="12"
                            sm="3"
                            md="3"
                        >
                          <label>Статус</label>
                          <v-select
                              @input="collectData"
                              class="rounded-lg custom__select"
                              v-model="clientsFilter.status"
                              :items="statusTypes"
                              item-value="value"
                              item-text="name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="3"
                            md="3"
                        >
                          <label>Этап</label>
                          <v-select
                              @input="collectData"
                              class="rounded-lg custom__select"
                              v-model="clientsFilter.product"
                              :items="list.monitor"
                              item-value="product.id"
                              item-text="product.name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="3"
                            md="3"
                        >
                          <label>Дата окончания</label>
                          <VueDatePicker
                              @input="collectData"
                              no-title
                              no-header
                              range
                              rangeInputText="%d - %d"
                              format="DD MMMM"
                              color="#629f34"
                              v-model="clientsFilter.date_creation"
                              style="flex: none !important;"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker"
                                  ref="activator"
                                  type="button"
                              >
                                <div>
                                  <span v-if="clientsFilter.date_creation">{{ date }}</span>
                                  <span v-else style="color: gray">Выберите период</span>
                                </div>
                                <v-icon
                                    medium
                                    right
                                    class="ml-5"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </button>
                            </template>
                          </VueDatePicker>
                        </v-col>

                      </v-row>
                      <v-row>
                        <v-card-actions class="mt-4">
                          <template v-if="!dialogButton">
                            <button
                                class="button custom__button mt-5"
                                type="button"
                                @click="returnClients"
                            >
                              Применить
                            </button>
                          </template>
                          <template v-else>
                            <button
                                class="button custom__button mt-5"
                                type="button"
                                @click="filterClients(clientsFilter)"
                                style="background-color: #A13453 !important;color: #fff !important;"
                            >
                              Применить
                            </button>
                            <button
                                class="button custom__button mt-5 ml-3"
                                type="button"
                                style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                @click="clearData"
                            >
                              Сбросить фильтр
                            </button>
                          </template>
                        </v-card-actions>
                      </v-row>
                    </v-container>
                  </v-card-text>
               
                </div>
  


                <v-data-table
                v-if="list && list.monitor"
                    :headers="headersDeals"
                    :items="list.monitor"
                    no-data-text="Результатов не найдено"
                    :hide-default-footer="true"
                    :page="page"
                    class="elevation-1"
                    :server-items-length="list.monitor.listLength"
                    :items-per-page="toggle_exclusive"
            >
            <template v-slot:body="{ items, headers }">
                <tbody name="list" is="transition-group" v-if="items.length > 0">
                  <tr v-for="item in items" :key="item.client.id">
                  <td>
                    <router-link v-if="item.client && item.client.id" :to="{ name: 'CardSubscribe', params: {client_id: item.client.id, product_id: item.product.id} }" style="align-items: center; text-decoration: none; color: #000">
                      {{ item.product.name }}
                    </router-link>
                  </td>
                  <td>           <router-link
                    v-if="item.client && item.client.id"
                        :to="{ name: 'CardClientNew', params: {client_id: item.client.id}}"
                        class="d-flex"
                        style="align-items: center; text-decoration: none; color: #000"
                    >
                      {{ item.client.name }}
                    </router-link></td>
                  <td>{{ formatDate(item.startdate) }}</td>
                  <td>{{ formatDate(item.enddate) }}</td>
                  <td>{{ item.status }}</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="v-data-table__empty-wrapper">
                  <td :colspan="headers.length">Данных не найдено</td>
                </tr>
                </tbody>
     
              </template>
            </v-data-table>
         
            <v-card-actions
                      class="d-flex justify-content-between"
                      style="padding: 20px !important;"
                  >
                    <template v-if="list.monitor && list.listLength">
                      <div>
                        <span class="desktopRegularLabel"><span>Показано с 1 по {{ toggle_exclusive }} из {{ list.listLength }} результатов</span></span>
                      </div>
                      <div>
                        <v-pagination
                            v-model="page"
                            circle
                            color="#629F33"
                            :length="list.paginationLength"
                            :total-visible="8"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-card-actions>
              </Block>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {globalMethods} from "@/mixins/globalMethods";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
//import { VueDatePicker } from '@mathieustan/vue-datepicker';
import {renewalActionTypes} from "@/store/modules/renewal";
//import {lessonActionTypes} from "@/store/modules/lesson";
import {mapState} from "vuex";

export default {
  name: 'MembersRenewal',
  props: ['specialistType', 'specialist_id', 'type', 'startdate', 'enddate'],
  mixins: [globalMethods],
  components: {
    Header,
    VueDatePicker,
    Menu,
  },
  data() {
    return {
      search: '',
      select: null,
      isLoading: false,
      selected: [],
      dialogFiler: false,
      dialogButton: false,
      valid: true,
      monitorDef:[],
      clientsFilter: {
        product: null,
        status: null,
        date_creation: null,
        date_end: null
      },
      page: 1,
      statusTypes: [
        {name: 'Активен', value: true},
        {name: 'Закрыт', value: false},
      ],
      showFilterGrid: false,
      rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      headersDeals: [
        {text: 'Продукт', align: 'start', value: 'product.name'},
        {text: 'Клиент', align: 'start', value: 'client.name'},
        {text: 'Начало', value: 'startdate'},
        {text: 'Окончание', value: 'enddate'},
        {text: 'Статус', value: 'status'},
      ],
      toggle_exclusive: 20
    }
  },
  computed: {
    ...mapState({
      isLoadingMonitor: state => state.renewal.isLoading,
      list: state => state.renewal.membersRenewalList,
      specialist: state => state.lesson.specialist,
      validationErrors: state => state.renewal.validationErrors
    })
  },
  methods: {
    fetchFeed(specialist_id, type, startdate, enddate, search) {
      console.log(type)

      let page = this.page
      let limit = this.toggle_exclusive

      let client_search = search ? search : null

      if (type === 'nodeal') {
        this.$store.dispatch(renewalActionTypes.getMembershipNodeals, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search
        }).then((response) => {
          this.monitorDef = response.monitor
        })
      } else {
        this.$store.dispatch(renewalActionTypes.getMembershipExtension, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search
        }).then((response) => {
          this.monitorDef = response.monitor
        })
      }
    },
    formatDate(date) {
      date = new Date(date);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const formattedDay = (day < 10) ? `0${day}` : day;
      const formattedMonth = (month < 10) ? `0${month}` : month;

      return `${formattedDay}.${formattedMonth}.${year}`;
    },
    collectData(selected) {
      this.selected.push(selected)
      if (this.selected !== [] || this.clientsFilter.date_creation !== null || this.clientsFilter.date_end !== null || this.clientsFilter.product !== null) {
        this.dialogButton = true;
      }
    },
    clearData() {
      this.selected.length = 0;
      this.clientsFilter.date_creation = null;
      this.clientsFilter.date_end = null;
      this.clientsFilter.product = null;
      this.clientsFilter.status = null;
      this.dialogButton = false;
      this.list.monitor = this.monitorDef
    },
    filterClients(clients) {
      console.log(clients)
      clients.status = clients.status ? 'Активен' : 'Закрыт'
      if (clients.product !== null) {
        this.list.monitor = this.monitorDef.filter((item) => item.product.name === clients.product);
      }
      if (clients.status !== null) {
        this.list.monitor = this.monitorDef.filter((item) => item.status === clients.status);
      }
      if (clients.date_creation !== null) {
      
        this.list.monitor = this.monitorDef.filter((item) => new Date(clients.date_creation.start) <= new Date(item.enddate) && new Date(item.enddate) <= new Date(clients.date_creation.end));
      }
    },
    returnClients() {
      if (!this.dialogButton) {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate);
      }
    },
  },
  mounted() {
    this.specialist_id !== undefined ? setItem('ext-specialist_id', this.specialist_id) : this.specialist_id = getItem('ext-specialist_id');
    this.type !== undefined ? setItem('tasks-type', this.type) : this.type = getItem('tasks-type');
    this.startdate !== undefined ? setItem('tasks-startdate', this.startdate) : this.startdate = getItem('tasks-startdate');
    this.enddate !== undefined ? setItem('tasks-enddate', this.enddate) : this.enddate = getItem('tasks-enddate');
    if(this.specialistType == 0) {
      this.specialist_id = null
    }
    this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate);
  },
  watch: {
    toggle_exclusive() {
      this.page = 1;
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate);
      }
    },
    page() {
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate);
      } else {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search);
      }
    },
    search() {
      if (this.search !== '') {
          this.loading = true
          this.specialist_id !== undefined ? setItem('ext-specialist_id', this.specialist_id) : this.specialist_id = getItem('ext-specialist_id');
          this.type !== undefined ? setItem('tasks-type', this.type) : this.type = getItem('tasks-type');
          this.startdate !== undefined ? setItem('tasks-startdate', this.startdate) : this.startdate = getItem('tasks-startdate');
          this.enddate !== undefined ? setItem('tasks-enddate', this.enddate) : this.enddate = getItem('tasks-enddate');
          if(this.specialistType == 0) {
            this.specialist_id = null
          }
            this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate,this.search);
        } else {
            this.loading = true
            this.specialist_id !== undefined ? setItem('ext-specialist_id', this.specialist_id) : this.specialist_id = getItem('ext-specialist_id');
            this.type !== undefined ? setItem('tasks-type', this.type) : this.type = getItem('tasks-type');
            this.startdate !== undefined ? setItem('tasks-startdate', this.startdate) : this.startdate = getItem('tasks-startdate');
            this.enddate !== undefined ? setItem('tasks-enddate', this.enddate) : this.enddate = getItem('tasks-enddate');
            if(this.specialistType == 0) {
              this.specialist_id = null
            }
            this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate);
        }
      }
  }
}
</script>
<style scoped lang="scss">
.filter {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }
    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {
    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.client {
  display: flex;
  align-items: center;

  .ava {
    margin-right: 8px;
  }
}

.filter {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }

    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {

    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {

      button {

        &:not(:last-child) {
          margin-right: 20px;
        }

      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.client {
  display: flex;
  align-items: center;

  .ava {
    margin-right: 8px;
  }

}

.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px !important;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A !important;
}
.search_client {
  min-width: 40%;
  display: flex;
  align-items: center;
}
</style>